export default {
	home: {
		name: "add goods"
	}
};
